export default function DeletePopUp({ onConfirm, onCancel, code, isChapter }) {
  const renderMessage = () => {
    if (!code) {
      return 'No item selected for deletion';
    }
      // You can break the message into parts and apply style to the `code` part
      switch (isChapter) {
        case 'chapter':
          return (
            <>
              Are you sure you want to delete this chapter{' '}
              <span style={{ fontWeight: 'bold', color: '#FF0000' }}>({code})</span> and 
              <span style={{ fontWeight: 'bold', color: '#FF0000' }}> all its related headings, subheadings, and classifications</span>?
            </>
          );
        case 'heading':
          return (
            <>
              Are you sure you want to delete this heading{' '}
              <span style={{ fontWeight: 'bold', color: '#FF0000' }}>({code})</span> and 
              <span style={{ fontWeight: 'bold', color: '#FF0000' }}> all its related subheadings and classifications</span>?
            </>
          );
        case 'subheading':
          return (
            <>
              Are you sure you want to delete this subheading{' '}
              <span style={{ fontWeight: 'bold', color: '#FF0000' }}>({code})</span> and 
              <span style={{ fontWeight: 'bold', color: '#FF0000' }}> all its related classifications</span>?
            </>
          );
        case 'classification':
          return (
            <>
              Are you sure you want to delete this classification{' '}
              <span style={{ fontWeight: 'bold', color: '#FF0000' }}>({code})</span>?
            </>
          );
        default:
          return '';
      }
  
  };

  return (
    <div className="fixed top-0 left-0 w-full h-full flex items-center justify-center bg-black bg-opacity-50 z-50  font-normal gap-20">
      <div className="bg-white p-5 border-y-4 border-pink-700 rounded-lg">
        <p className="text-center mb-4">
          {renderMessage()}
        </p>
        <div className="flex justify-end gap-5">
          <button
            onClick={onConfirm}
            className="bg-red-600 text-white px-4 py-2 rounded-lg hover:bg-red-400"
          >
            Yes, Delete
          </button>
          <button
            onClick={onCancel}
            className="bg-gray-600 text-white px-4 py-2 rounded-lg"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}
